import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from "../common-utilities.service";
import { EditUserInfoService } from './edit-user-info.service';
import { constants } from '../constants';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-edit-user-info',
  templateUrl: './edit-user-info.component.html',
  styleUrls: ['./edit-user-info.component.scss']
})
export class EditUserInfoComponent implements OnInit {

  //variables del modal
  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  //variables del formulario
  editInfoForm: FormGroup;
  emailPattern = constants.REGEX_EMAIL_PATTERN;
  isBtnDisabled = false;
  userData = null;

  //constructor del componente
  constructor(public LANG: CommonUtilitiesService, private formbuilder: FormBuilder, private editUserInfoService: EditUserInfoService) { }

  ngOnInit() {

    this.editInfoForm = this.formbuilder.group({      
      inputNames: ['', []],
      inputLastNames: ['', []],
      inputBornDate: ['', []],
      inputMainMail: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      inputCity: ['', []],
      inputMainPhone: ['', []],
      inputAddress: ['', []]      
    });

    //datos iniciales
    this.userData = JSON.parse(localStorage.getItem("userData"));
    this.setFormData();
  }


  /**
  * Description: Método que obtiene los datos de registro civil
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  setFormData(){
    this.isBtnDisabled = true;
    this.editUserInfoService.getInfoByDocument(this.userData.documentType, this.userData.documentId).subscribe((dataInfo => {  
      this.isBtnDisabled = false;
      var formatedDate = "";
      if (dataInfo['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {
        formatedDate = (dataInfo["obj"].birthDate).split("-");
        formatedDate = formatedDate[2] + "/" + formatedDate[1] + "/" + formatedDate[0];
      }      
      this.editInfoForm.patchValue({ inputNames: this.userData.name });
      this.editInfoForm.patchValue({ inputLastNames: this.userData.lastName });
      this.editInfoForm.patchValue({ inputBornDate: formatedDate });
      this.editInfoForm.patchValue({ inputMainMail: this.userData.email.toLowerCase() });
      this.editInfoForm.patchValue({ inputCity: this.userData.location });
      let phone = "";
      if(this.userData.isMainPhone){
        phone = this.userData.phone;
      }
      this.editInfoForm.patchValue({ inputMainPhone: phone });
      this.editInfoForm.patchValue({ inputAddress: this.userData.address });
    }));
  }


  /**
  * Description: Método que actualiza número y email principal
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  updateUserMainData() {

    let accountId = this.userData.billingAccountId;

    if (this.editInfoForm.get('inputMainMail').invalid || accountId == null) {
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
      this.isShowModal = true;
      return;
    }

    //actualiza datos en WS
    this.isBtnDisabled = true;
    this.editUserInfoService.updateUserMainInfo(accountId, this.editInfoForm.get('inputMainMail').value).subscribe((data => {
      this.isBtnDisabled = false;
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return false;
      }

      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_INFO');
      this.modalContent = this.LANG.getLangText('LABEL_MODAL_SUCESS');
      this.isShowModal = true;
      return false;

    }),
      (err) => {
        this.isBtnDisabled = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }

   /**
   * Description: Método que envía el codigo de validación por SMS
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  hideModal() {
    this.isShowModal = false;
  }

}
